import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import useApiManager from '../../utils/Api/apiManager';
import { useNavigate } from "react-router-dom";

const UsersDataGrid = () => {
    const [rows, setRows] = useState([]);
    const [rowCount, setRowCount] = useState(0);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const { get } = useApiManager();


    const columns = [
        { field: 'id', headerName: 'ID', flex: 0.5 },
        { field: 'firstName', headerName: 'First Name', flex: 1 },
        { field: 'lastName', headerName: 'Last Name', flex: 1 },
        { field: 'email', headerName: 'Email', flex: 1.5 },
        { field: 'externalId', headerName: 'External Id', flex: 1 },
        { field: 'roles', headerName: 'Role', flex: 0.8 },
    ];

    const transformData = (data) => {
        return data.map(item => ({
            id: item.id,
            firstName: item.firstName,
            lastName: item.lastName,
            email: item.email,
            externalId: item.externalId,
            roles: item.roles[0]
        }));
    };

    useEffect(() => {
        const fetchAndSetData = async () => {
            setLoading(true);
            try {


                const data = await get('/users/');
                setRows(transformData(data));
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchAndSetData();
    }, []);

    const handleRowClick = (params) => {
        navigate(`/admin/${params.id}`);
    };

    return (
        <DataGrid
            rows={rows}
            columns={columns}
            columnVisibilityModel={{
                id: false,
            }}
            getRowId={(row) => row.id}
            initialState={{
                pagination: {
                    paginationModel: {
                        pageSize: 50,
                    },
                },
            }}
            pageSizeOptions={[50, 75, 100]}
            loading={loading}
            onRowClick={handleRowClick}
            sx={{
                height: '100%', // Fills the parent container
                '& .MuiDataGrid-virtualScroller': {
                    overflow: 'auto', // Ensures scrollbars appear when necessary
                },
            }}
        />
    );
};

export default UsersDataGrid;
